


















































































































import BaseItemsPage from "../BaseItemsPage";
import { ViberDetailItem } from "@/store/viber/statistic/types";
import { Component } from "vue-property-decorator";
import ViberDetailFilter from "@/components/Viber/Statistic/ViberDetailFilter.vue";
import { Getter } from "vuex-class";
import { dateFilter } from "@/utils/date-util";
import { ScrollButton } from "wings-ui-components";
import { colorClassByStatus } from "@/utils/page-utils";

@Component({
  components: {ViberDetailFilter, ScrollButton},
  filters: {dateFilter},
  methods: {colorClassByStatus},
})
export default class ViberDetail extends BaseItemsPage<ViberDetailItem> {

  @Getter("viberStatisticDetail") responseItems!: ViberDetailItem[];
  @Getter("isLoadingDetailStat") isLoadingDetailStat!: boolean;

  is_show_filter_additional: boolean = false;
  currentSort: string = "create_date";

  tableFields: string[] = this.tableFieldsDefault;

  get tableFieldsDefault(): string[] {
    return [
      'create_date', 'originator', 'recipient', 'partner',
      'service_provider', 'message', 'status', 'detail',
    ];
  }

  getData(): ViberDetailItem[] {
    return this.responseItems;
  }
}
